import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Button, Input, InputGroup, InputGroupAddon, Label} from 'reactstrap';
import autobind from 'autobind-decorator';
import {deleteTemplate, saveTemplate, selectTemplate, updateTemplate, uploadTemplateFile} from 'template/actions';
import Dialog from 'apa/containers/Dialog';

@connect(
    state => ({
        selectedTemplate: state.template.selectedTemplate
    }),
    dispatch => {
        return {
            updateManual: (manual) => dispatch(updateTemplate(manual)),
            saveManual: (manual) => dispatch(saveTemplate(manual)),
            deleteManual: (manual) => dispatch(deleteTemplate(manual)),
            selectManual: (manual) => dispatch(selectTemplate(manual)),
            uploadManualFile: (manualId, data, success) => dispatch(uploadTemplateFile(manualId, data, success)),
        }
    }
)
export default class TemplatePreview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            template_file: props.selectedTemplate.template_file,
            isDeleteOpen: false,
            uploading: false,
            template: '',
            preview: false,
            uploadError: false,
        }
    }

    @autobind
    confirmDelete() {
        this.props.deleteManual(this.props.selectedTemplate);
        this.toggleDelete()
    }

    @autobind
    toggleDelete() {
        this.setState({
            isDeleteOpen: !this.state.isDeleteOpen
        })
    }

    @autobind
    uploadManualFile(e) {
        this.setState({
            uploading: true
        })
        const data = new FormData()
        const f = e.target.files[0]
        data.append('template_file', f, f.name)
        this.props.uploadManualFile(
            this.props.selectedTemplate.id,
            data,
            () => this.setState({
                uploading: false
            }),
            () => this.setState({
                uploading: false,
                uploadError: true
            })
        )
    }

    render() {
        const {
            selectedTemplate,
        } = this.props;
        const manual = selectedTemplate;
        return (
            <Fragment>
                <Label>
                    Name
                </Label>
                <InputGroup>
                    <Input
                        type='text'
                        value={selectedTemplate.name}
                        onChange={e => this.props.updateManual({...manual, name: e.target.value})}
                        onBlur={() => this.props.saveManual(manual)}
                    />
                    <InputGroupAddon addonType='append'>
                        <Button color='danger' onClick={this.toggleDelete}>
                            <i className='fa fa-trash'> </i>
                        </Button>
                        <Dialog
                            toggle={this.toggleDelete}
                            confirm={this.confirmDelete}
                            isOpen={this.state.isDeleteOpen}
                        >
                            Sind Sie sicher?
                        </Dialog>
                    </InputGroupAddon>
                </InputGroup>
                <Label>
                    Neue Vorlage hochladen
                </Label>
                <Input
                    type='file'
                    value={this.state.template}
                    onChange={this.uploadManualFile}
                />
                {this.state.uploading && <Loading/>}
                {this.state.uploadError && <p className='text-danger'>Fehler beim Upload.</p>}
                <br/>
                <a href={manual.template_file} target="_blank" rel="noopener noreferrer"
                   className='btn btn-primary'>Download</a>
                <Button color={'primary'} onClick={() => this.setState({preview: !this.state.preview})}>Vorschau
                    öffnen</Button>
                {this.state.preview &&
                <Fragment>
                    <br/>
                    <iframe
                        src={'https://view.officeapps.live.com/op/embed.aspx?src=https://apa.menshikov.de' + manual.template_file + '?' + Date.now()}
                        frameBorder="0"
                        width="100%"
                        height="900"
                    >
                        Office365 Vorschau
                    </iframe>
                </Fragment>
                }
            </Fragment>
        )
    }

}
